
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME
// GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME


const GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME= createAsyncThunk(
  "getAllBlogSectionsWithCreatorBySectionName/getAllBlogSectionsWithCreatorBySectionName",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllBlogSectionsWithCreatorBySectionNameSlice = createSlice({
  name: "getAllBlogSectionsWithCreatorBySectionNameSlice",
  initialState: {
    getAllBlogSectionsWithCreatorBySectionName: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllBlogSectionsWithCreatorBySectionName: (state) => {
        state.getAllBlogSectionsWithCreatorBySectionName.loading = false
        state.getAllBlogSectionsWithCreatorBySectionName.error = false
        state.getAllBlogSectionsWithCreatorBySectionName.data = []
        state.getAllBlogSectionsWithCreatorBySectionName.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME.fulfilled, (state, action) => {
      state.getAllBlogSectionsWithCreatorBySectionName = {
        ...state.getAllBlogSectionsWithCreatorBySectionName,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME.pending, (state, action) => {
      state.getAllBlogSectionsWithCreatorBySectionName = {
        ...state.getAllBlogSectionsWithCreatorBySectionName,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME.rejected, (state, action) => {
      state.getAllBlogSectionsWithCreatorBySectionName = {
        ...state.getAllBlogSectionsWithCreatorBySectionName,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllBlogSectionsWithCreatorBySectionNameAction = {
    GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME,
};

export { getAllBlogSectionsWithCreatorBySectionNameAction };
export default getAllBlogSectionsWithCreatorBySectionNameSlice.reducer;
export const {setInitialStateOfgetAllBlogSectionsWithCreatorBySectionName} = getAllBlogSectionsWithCreatorBySectionNameSlice.actions
